<template>
  <div>
    <!-- 富文本测试 -->
    <div class="tui-quillContent">
      <!-- v-model="isNewValue" -->
      <quill-editor
        :value="isDomValue"
        @input="changeValue"
        :options="editorOption"
        ref="myQuillEditor"
        @change="onEditorChange($event)"
      ></quill-editor>
      <div style="text-align: right">{{ TiLength }}/{{ textLength }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            //下面是控制工具栏的展示功能 见 https://blog.csdn.net/qq_36947168/article/details/119486710
            // https://www.kancloud.cn/liuwave/quill/1409378
            ["bold", "italic", "underline"],
            // ['blockquote', 'code-block'],
            // [{ 'header': 1 }, { 'header': 2 }],
            // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            // [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
            // [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large"] }],
            // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }],
            // [{ font: [] }],
            // [{ 'align': [] }],
            // ['clean'],
            // ['image','video']
          ],
        },
      },
      TiLength: 0,
      isNewValue: "",
    };
  },
  props: {
    textLength: {
      type: Number,
      default: 2000,
    },
    isDomValue: {
      type: String,
      default: "",
    },
  },
  mounted() {
    //数据初始化
    this.TiLength = this.$refs.myQuillEditor.quill.getLength() - 1;
  },
  // watch: {
  //   isDomValue: {
  //     handler(val) {
  //       console.log("dataObj deep change", val);
  //       this.isNewValue = val;
  //     },
  //     deep: true, // 深度监听
  //     immediate: true, // 初次监听即执行
  //   },
  // },
  methods: {
    changeValue(e) {
      // console.log(e, "123");
      this.$emit("update:isDomValue", e);
      this.$emit("change", e);
    },
    onEditorChange(event) {
      event.quill.deleteText(this.textLength, 1);
      if (this.isDomValue === "") {
        this.TiLength = 0;
      } else {
        this.TiLength = event.quill.getLength() - 1;
      }
    },
    get_value(e) {
      console.log(e, "eeeeeeeeeee");
    },
  },
};
</script>
<style lang="scss" scoped>
</style>